(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));

  // global-externals:react
  var require_react = __commonJS({
    "global-externals:react"(exports, module) {
      module.exports = React;
    }
  });

  // custom.jsx
  var import_react = __toESM(require_react());

  var TShirt = ({ data, setDataDefaults, errors, InputField, CheckBox, donation }) => {
    const eligibleForGift = donation.usdAmount.gte(100);
    (0, import_react.useEffect)(() => {
      setDataDefaults({
        eligibleForGift,
        acceptGift: true,
        shippingStreet1: "",
        shippingStreet2: "",
        shippingCity: "",
        shippingState: "",
        shippingZip: ""
      });
      donation.setShares([
        "basic_with_beneficiary",
        "extended_with_beneficiary",
        "address_with_beneficiary",
        "with_partner"
      ]);
    }, []);
    (0, import_react.useEffect)(() => {
      data.set("eligibleForGift", eligibleForGift);
    }, [eligibleForGift]);
    return /* @__PURE__ */ import_react.default.createElement("div", { className: "my-4" }, /* @__PURE__ */ import_react.default.createElement("h2", { className: "h5 section-heading section-heading-t-shirt" }, "Mattel Donation Gift"), eligibleForGift ? /* @__PURE__ */ import_react.default.createElement(import_react.default.Fragment, null, /* @__PURE__ */ import_react.default.createElement("div", { className: "mb-3" }, /* @__PURE__ */ import_react.default.createElement(
      CheckBox,
      {
        id: "acceptGift",
        label: "\n                As a thank you for your gift of $100 or more, would you like us to\n                mail you the surprise gift(s) from Mattel?\n              ",
        checked: data.get("acceptGift", false),
        onChange: (e) => data.set("acceptGift", e.target.checked)
      }
    )), data.acceptGift && /* @__PURE__ */ import_react.default.createElement(import_react.default.Fragment, null, /* @__PURE__ */ import_react.default.createElement(
      InputField,
      {
        id: "shippingStreet1",
        label: "Street address",
        value: data.get("shippingStreet1"),
        onChange: (e) => data.set("shippingStreet1", e.target.value),
        error: errors.firstFor("shippingStreet1")
      }
    ), /* @__PURE__ */ import_react.default.createElement(
      InputField,
      {
        id: "shippingStreet2",
        label: "Apt, suite, etc. (optional)",
        value: data.get("shippingStreet2"),
        onChange: (e) => data.set("shippingStreet2", e.target.value),
        error: errors.firstFor("shippingStreet2")
      }
    ), /* @__PURE__ */ import_react.default.createElement(
      InputField,
      {
        id: "shippingCity",
        label: "City",
        value: data.get("shippingCity"),
        onChange: (e) => data.set("shippingCity", e.target.value),
        error: errors.firstFor("shippingCity")
      }
    ), /* @__PURE__ */ import_react.default.createElement(
      InputField,
      {
        id: "shippingState",
        label: "State",
        value: data.get("shippingState"),
        onChange: (e) => data.set("shippingState", e.target.value),
        error: errors.firstFor("shippingState")
      }
    ), /* @__PURE__ */ import_react.default.createElement(
      InputField,
      {
        id: "shippingZip",
        label: "ZIP code",
        value: data.get("shippingZip"),
        onChange: (e) => data.set("shippingZip", e.target.value),
        error: errors.firstFor("shippingZip")
      }
    ))) : /* @__PURE__ */ import_react.default.createElement("div", { className: "alert alert-info" }, "Donations of $100 or more will receive one of three surprise gifts from Mattel, featuring items from beloved brands like Hot Wheels, Fisher-Price, or UNO (while supplies last). The first 1000 donors will also receive an Autistic Barbie"));
  };
  var paymentMethods = ["fiat", "crypto", "deferred", "wire_check"];
  var supported = (paymentMethod) => paymentMethods.includes(paymentMethod);
  var AfterSub = ({ paymentMethod, ...props }) => supported(paymentMethod) && /* @__PURE__ */ import_react.default.createElement(TShirt, { ...props });
  var plugin = {
    hooks: { afterSubscription: AfterSub },
    collectData: `only:${paymentMethods}`,
    validate: ({ paymentMethod, data }) => supported(paymentMethod) && data.eligibleForGift && data.acceptGift && data.validate({
      shippingStreet1: { required: true },
      shippingCity: { required: true },
      shippingState: { required: true },
      shippingZip: { required: true }
    })
  };
  root.dispatchEvent(new CustomEvent("addPlugin", { detail: plugin }));
})();
